import request from "./http";
import qs from 'qs'
/**
	//  * 获取树形结构数据
	 * @param appType 
	 * @param appTypeNos 
	 * @param {Object} callback
	 */
 export function getReadDeviceTree(params) {
    return request({
      url: "/menus/findReadDeviceTree",
      method: "get",
      params
  });
  };

/**
//  * 获取区域列表
 */
export function getFindAreaList() {
    return request({
        url: "/area/findAreaList",
        method: "get",
    });
}



/**
//  * 首页看板综合数据
 * @param {string} areaId 区域id
 * @param {string} timeType 	查询类型: YEAR,MONTH,DAY
 */
export function getEnergyStatistics(params) {
    return request({
        url: "/building/energyStatistics",
        method: "get",
        params,
    });
}


// 	 * 健康指数->查询报警和事件信息
export function countUnitEvents() {
    return request({
        url: "/event/countUnitEvents.do",
        method: "get",
        headers:{
            'Content-Type':'application/x-www-form-urlencoded',
            'Accept':'*/*'
          },
    });
}



/**
//  * 建筑信息(暂不用)
 * 
 */
 export function GetBuildingByUnitIdConditions(params) {
    return request({
        url: "/energyBuilding/findBuildingByConditions.do",
        method: "get",
        params,
    });
}

//上传图片
// export const  UploadPic = params => {
//   let formData = changeToFormData(params);
//   return axios.post('/resources/uploadByBytes.do',formData).then(res => res.data);
// }
/**
//  * 上传图片
 * 
 */
export function UploadPic(params) {
    return request({
        url: "/images/Upload/Pic",
        method: "post",
        params
    });
}

/**
//  * 上传报表
 * 
 */
 export function GetExcelTemplateDirectorieXlsx() {
    return request({
        url: "/api/ExcelReport/GetExcelTemplateDirectorieXlsx",
        method: "get",
    });
}



// /**
/**
	 * 保存单位
	 * @param {String} id 单位id 不传默认添加否则更新
	 * @param {String} type 类型   0企业 /1组织架构
	 * @param {String} parentId 上级ID
	 * @param {String} unitCode 编号
	 * @param {String} name 单位名称
	 * @param {String} fullName 全称
	 * @param {String} address 地址
	 * @param {String} leader 负责人
	 * @param {String} phoneNum 联系方式
	 * @param {String} memo 备注
	 * @param {int} sort 排序
	 * @param {int} capacity 变压器总容量
	 * @param {String} inletWire 进线来源
	 * @param {String} location 地理坐标
	 * @param {String} joinTime 接入时间
	 * @param {String} expirationTime 合同到期时间
	 * @param {String} roomCount 电房数量
	 * @param {String} transformerCount 变压器数量
	 * @param {int} loadCapacity 负荷容量
	 * @param {String} unitArea 单位面积
	 * @param {String} unitPeopleNumber 单位人数 
	 * @param {String} energIndex 能耗指标
	 * @param {String} energySavingRatio 目标节能比例
	 */
export function saveUnit(id, type, parentId, unitCode, name, fullName, address, leader, phoneNum, memo, sort, capacity, inletWire, location, joinTime,
    expirationTime, roomCount, transformerCount, loadCapacity,unitArea,unitPeopleNumber,energIndex,energySavingRatio) {
    return request({
        url: "/unit/saveUnit.do",
        method: "post",
        headers:{
            'Content-Type':'application/x-www-form-urlencoded',
            'Accept':'*/*'
          },
        data:qs.stringify({
            id,
				type,
				parentId,
				unitCode,
				name,
				fullName,
				address,
				leader,
				phoneNum,
				memo,
				sort,
				capacity,
				inletWire,
				location,
				joinTime,
				expirationTime,
				roomCount,
				transformerCount,
				loadCapacity,
				unitArea,
				unitPeopleNumber,
				energIndex,
				energySavingRatio,
        })
    });
}

// /**
// 	 * 系统管理——搜索查询用户
// 	 */
export function sysMenuGetUserByUserCode(params) {
    return request({
        url: "/sysMenu/getUserByUserCode",
        method: "get",
        headers:{
            'Content-Type':'application/x-www-form-urlencoded',
            'Accept':'*/*'
          },
          params
    });
}

// /**
// 	 * 系统管理——通过角色Id搜索查询用户(下拉框)
// 	 */
export function sysMenuGetUserByroleId(params) {
    return request({
        url: "/sysMenu/getUserByroleId",
        method: "get",
        headers:{
            'Content-Type':'application/x-www-form-urlencoded',
            'Accept':'*/*'
          },
          params
    });
}


/**
	 * 获取所有权限（菜单）
	 */
 export function getAllRightNew(params) {
    return request({
        url: "/sysMenu/getAllRight.do",
        method: "get",
        params
    });
}


//  * 上传电子档案
export function saveRecord(params) {
    return request({
        url: "/file/saveRecord",
        method: "post",
        headers:{
            'Content-Type':'multipart/form-data',
            'Accept':'*/*'
          },
          data:params
    });
}
//  * 获取电子档案
export function findUnitRecord() {
    return request({
        url: "/file/findUnitRecord",
        method: "get",
 
    });
}

//  * 获取月度报告
export function findUnitMonthlyReport() {
    return request({
        url: "/file/findUnitMonthlyReport",
        method: "get",
 
    });
}

/**
	 * 电能质量
     * dateType	时间类型（day,month,year）	
        deviceNo	设备编号	
        electricPower	设备编号,可用值:voltageUnbalance,currentUnbalance,frequencyDeviation,voltageDistortionRate,oddHarmonicInclusionRate,evenHarmonicInclusionRate	query	true	
        time 查询时间
	 */
 export function getCountPower(params) {
    return request({
        url: "/power/countPower",
        method: "get",
        params
    });
}

/**
	 * 线损变损
     * nodeId	节点id
     * lossType损耗类型：lineLoss-线损；deterioration-变损
        type（日期类型）
        startTime（查询开始时间
        endTime（查询结束时间）
	 */
        export function getEnergyLossList(params) {
            return request({
                url: "/diagram/getEnergyLineLoss",
                method: "get",
                params
            });
        }

/**
	 * LOGO配置->获取所有logo信息
     
	 */
        export function getLogoList(params) {
            return request({
                url: "/logo/getAll",
                method: "get",
                params
                
            });
        }

        /**
	 * LOGO配置->获取当前logo信息
     
	 */
         export function getNowLogo(params) {
            return request({
                url: "/logo/getLogo",
                method: "get",
                params
                
            });
        }


//LOGO配置->添-修改logo信息和系统名称
// /enable	是否使用：0-未使用，1-使用(添加默认为0)		
// id	主键id，添加-不传id，修改-传id		
// logoInfo	logo信息		
// systemName	系统名称
// 
export function logoSave(params) {
    return request({
        url: "/logo/save",
        method: "post",
        headers:{
            'Content-Type':'application/json',
            'Accept':'*/*'
          },
        data:params
 
    });
}


//  *查询本月，上个月最大需量
export function findDemand(params) {
    return request({
        url: "/demand/findDemand",
        method: "get",
        timeout: 5400000,
        params
    });
}


//  *看板电费电量
export function getClassPGByMonthForHuaPu(params) {
    return request({
        url: "/cost/findCostFromMonth",
        method: "get",
        timeout: 5400000,
        params
    });
}


/**
	 * 通过typeCode和groupNo查询台账
	 *
	 */
 export function getArchivesListByTypeCodeAndGroupNo(params) {
    return request({
        url: "/archives/getArchivesListByTypeCode.do",
        method: "post",
        params
    });
}

/**
	 * 新建消缺信息
	 *
	 */
 export function saveDefect(params) {
    return request({
        url: "/workDefect/saveDefect.do",
        method: "post",
        params
    });
}

	/**
	 * 删除消缺检查项
	 * @param {String} pkid
	 */
     export function deleteDefect(params) {
        return request({
            url: "/workDefect/deleteDefect.do",
            method: "delete",
            params
        });
    }

/**
	 * 检查设备是否被绑定
	 * @param {String} deviceNo
	 */
 export function existsByDeviceNo(params) {
    return request({
        url: "/archives/existsByDeviceNo",
        method: "get",
        params
    });
}


/**
	 * 消缺管理->查询台账设备下消缺检查项列表
	 * @param {String} deviceNo
	 */
 export function findDefectActionList(params) {
    return request({
        url: "/workDefect/findDefectActionList",
        method: "get",
        params
    });
}


/**
	 * 消缺管理->变更消缺操作状态
     * 	"executorStatus": "",执行状态：0-未处理，1-处理中，2-已完结,可用值:INITIAL,EXECUTORY,FINISHED
	"executorType": "",执行类型：0-人工，1-工单,可用值:ARTIFICIAL,ORDER
	"executorUser": "",	执行人
	"orderNo": 0,工单号
	"pkid": 0缺陷id
	 * @param {String} deviceNo
	 */
 export function executorStatus(params) {
    return request({
        url: "/workDefect/executor/status",
        method: "put",
        headers:{
            'Content-Type':'application/json',
            'Accept':'*/*'
          },
        data:params
    });
}



/**
	 菜单上升下降
	 * @param {String} 
	 */
    export function webMenuRise(params) {
        return request({
            url: "/menu/exchangeSerial",
            method: "put",
            params
        });
    }

/**
	权限菜单->菜单移动到其他菜单做子菜单
	 * @param {String} 
	 */
     export function webMenuMove(params) {
        return request({
            url: "/menu/moveMenu",
            method: "put",
            params
        });
    }
    
 /**
	 * 查询用户所属的单位以及下属单位树
	 */
  export function getUnitTree() {
    return request({
        url: "/unit/getUnitTree.do",
        method: "post",
    });
}
 

/**
	 * 日志管理->用户登录退出日志查询
	 */
 export function getUserLoginLog(params) {
    return request({
        url: "/log/getUserLoginLog",
        method: "get",
        params
    });
}
 


/**
	 * 需量->查询日最大需量
	 */
 export function findDemandByDay(params) {
    return request({
        url: "/demand/findDemandByDay",
        method: "get",
        params
    });
}
 
/**
	 * 需量->查询月最大需量
	 */
 export function findDemandByMon(params) {
    return request({
        url: "/demand/findDemandByMon",
        method: "get",
        params
    });
}
 

//遥控配置
/**
	 * 遥控配置->获取组分页列表信息
	 */
 export function operationGroupList(params) {
    return request({
        url: "/operation/group/list",
        method: "get",
        params
    });
}

/**
	 * 遥控配置->模糊查询分页列表信息
	 */
 export function vagueOperationGroupList(params) {
    return request({
        url: "/operation/operation/vague",
        method: "get",
        params
    });
}

/**
	 * 遥控配置->获取操作项列表
	 */
 export function operationList(params) {
    return request({
        url: "/operation/operation/list",
        method: "get",
        params
    });
}

/**
	 * 遥控配置->保存操作组信息
	 */
 export function saveOperationListGroup(params) {
    return request({
        url: "/operation/group/save",
        method: "post",
        headers:{
            'Content-Type':'application/json',
            'Accept':'*/*'
          },
        data:params
    });
}

/**
	 * 遥控配置->删除组及关联操作项信息
	 */
 export function delOperationListGroup(params) {
    return request({
        url: "/operation/group/delete",
        method: "DELETE",
        params
    });
}


/**
	 *遥控配置->保存操作项信息
	 */
 export function saveOperationList(params) {
    return request({
        url: "/operation/operation/save",
        method: "post",
        headers:{
            'Content-Type':'application/json',
            'Accept':'*/*'
          },
        data:params
    });
}

/**
	 * 遥控配置->删除操作项信息
	 */
 export function delOperationList(params) {
    return request({
        url: "/operation/operation/delete",
        method: "DELETE",
        params
    });
}


/**
	 * 设备控制->获取设备控制配置信息
	 */
 export function findControlManage() {
    return request({
        url: "/control/manage/findControlManage",
        method: "get",
    });
}


/**
	 * 设备控制->查询控制设备信息列表 
	 */
 export function findDeviceList(params) {
    return request({
        url: "/control/info/findDeviceList",
        method: "get",
        params
    });
}


/**
	 * 设备控制->修改设备控制配置信息
	 */
 export function saveControlManage(params) {
    return request({
        url: "/control/manage/saveControlManage",
        method: "POST",
        data:params
    });
}

/**
	 * 设备控制->添加遥控控制设备
	 */
 export function saveDevices(params) {
    return request({
        url: "/control/info/saveDevices",
        method: "POST",
        data:params
    });
}

/**
	 * 设备控制->修改开关次数总量
	 */
 export function updateDevice(params) {
    return request({
        url: "/control/info/updateDevice/operation",
        method: "put",
        params
    });
}

/**
	 * 设备控制->修改开关次数总量
	 */
 export function removeDevice(params) {
    return request({
        url: "/control/info/removeDevice",
        method: "DELETE",
        params
    });
}

/**
	 * 设备控制->分页查询遥控控制设备日志信息
	 */
 export function findAllByPagecontrol(params) {
    return request({
        url: "/control/log/findAllByPage",
        method: "get",
        params
    });
}

/**
	 * 电管管理列表
	 */
 export function getUnitMeterReadingConfigLimit(params) {
    return request({
        url: "/meterReading/getUnitMeterReadingConfigLimit.do",
        method: "POST",
        params
    });
}


/**
	 * 业主管理列表
	 */
 export function getOwnerList(params) {
    return request({
        url: "/meterReading/getOwnerList.do",
        method: "POST",
        params
    });
}
